module.exports = __webpack_public_path__ + "img/lcicon.eb65b57d.svg";